import React from 'react';
import { Navigate } from 'react-router-dom';

import { Login as LoginComponent } from '../components/Login';
import { useAuthContext } from '../hooks/use-user-auth-context.hooks';
import { User } from '../redux/slice/auth/auth.types';

export const Login: React.FC = () => {
  const user: User | null = useAuthContext();
  const isAuthenticated: boolean = user ? true : false;

  return isAuthenticated ? (
    <Navigate to="/pre-employment/start" />
  ) : (
    <div className="login-signup-bg py-24">
      <LoginComponent />
    </div>
  );
};
